









import { Component, Vue } from 'vue-property-decorator'

@Component
export default class NotFoundPage extends Vue {
  created () {
    // console.log('404 created')
  }

  mounted () {
    // console.log('404 mounted')
  }
}
